import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Modal } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Button } from '@/shared/uikit/Button';
import { Title } from '@/shared/uikit/Title';

import { useModalsStore } from '../../modals.store';
import { DeleteAssetsConfirmProps } from '../../types';

// TODO Delete confirm
export const DeleteAssetsConfirm: FC<DeleteAssetsConfirmProps> = ({ assets, count, onConfirm }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'deleteAssetsConfirm' });
  const modals = useModalsStore();

  const actions = [
    <Button style={{ height: 44 }} type="default" onClick={modals.closeModal} key="cancel">
      {t('btnCancel')}
    </Button>,
    <Button
      style={{
        height: 44,
        background: COLORS.systemFlame200,
        color: COLORS.systemLight100,
        fontSize: 14,
      }}
      type="primary"
      onClick={() => {
        modals.closeModal();
        onConfirm();
      }}
      key="confirm"
    >
      {t('btnConfirm', { count })}
    </Button>,
  ];

  return (
    <StyledModal
      width={600}
      wrapClassName="my-custom-modal"
      title={<Title size={22}>{t('title')}</Title>}
      footer={actions}
      onClose={modals.closeModal}
      onCancel={modals.closeModal}
      open
    >
      <Content>
        <Message>{t('message')}</Message>
        <List className="uikitScrollbar">
          {assets.map((item, index) => (
            <li className="asset" key={index}>
              {item.nickName ?? item.nickname}
            </li>
          ))}
        </List>
      </Content>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .my-custom-modal .ant-modal-content {
    padding-inline: 0 !important;
    background: red !important;
  }
`;

const Content = styled.div`
  margin-left: -24px;
  margin-right: -24px;

  border-top: 1px solid ${COLORS.systemDark100};
  border-bottom: 1px solid ${COLORS.systemDark100};
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Message = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
`;

const List = styled.ul`
  max-height: 200px;
  overflow: auto;

  & .asset {
    margin-bottom: 4px;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
    list-style-position: inside;
  }
`;
